
import { isWithinInterval } from 'date-fns';
import React from 'react';
import { CONTENT_TYPES } from '../../constants/contentTypes';

import * as Actions from './actions';

const UPDATE_INTERVAL = 1;

const addOrRemoveClassNames = (player, classNames = {}) => {
  for (let clave in classNames) {
    if (player.hasClass(clave) && !classNames[clave]) {
      player.removeClass(clave);
    };
    if (!player.hasClass(clave) && !!classNames[clave]) {
      player.addClass(clave);
    };
  }
};

export const useCleanupPlayer = (player, dispatch, playerCallback) => {
  return React.useCallback(
    () => {
      player?.then((p) => {
        console.log('>> CLEANUP PLAYER  -return: ', player);
        p?.dispose();
        if (playerCallback?.clearPlayerCallback) {
          playerCallback.clearPlayerCallback();
        }
      })

    },
    [dispatch, player, playerCallback]
  );
}

/**
 * Hook for TBXPlayer initialization
 *
 * @export
 * @param {*} props
 * @param {*} context
 * @param {*} container
 * @returns
 */
export function useTBXPlayerModule(state, PLAYER_CONTAINER_REF, dispatch, playerHandleError, playerCallback, _cleanupPlayer, isNextEpisode) {
  const { TBX_UNITY_API } = window.__TBX_ENV__;

  const _launchPlayer = React.useCallback(
    async (videoEl, {
      autoplay,
      pictureInPictureToggle,
      contentId,
      castAppId,
      environment = 'production',
      fill,
      fluid,
      image,
      jwtToken,
      playerID,
      responsive,
      pluginConfig,
      fullWindow
    }) => {
      //INFO: Ver configuraciones de TBXPlayer para moduleConfig
      const playerId = `${playerID}-${Date.now()}-${Math.random().toString(32).substr(2)}`
      const moduleConfig = {
        appId: castAppId,
        autoplay,
        baseUrl: TBX_UNITY_API,
        contentId,
        environment,
        jwtToken,
        pluginConfig,
        playerId: playerId,
        controlBarChildren: {
          'pictureInPictureToggle': pictureInPictureToggle,
        }
      };
      try {
        const hasCatchUpBool = state?.content?.startTime && state?.content?.endTime && state?.content?.hasCatchUp && !isWithinInterval(Date.now(), {
          start: new Date(state?.content.startTime),
          end: new Date(state?.content.endTime)
        })

        if (!playerCallback?.state?.nodeElement) {
          videoEl.setAttribute('id', playerId);
          const player = window.TbxPlayer.PlayerBuilder
            .moduleInit(videoEl, moduleConfig)
            .then((player) => {
              if (!player) throw new Error('>>>>>> Player promise: ', player);
              addOrRemoveClassNames(player, {
                'tbx-hascatchup': hasCatchUpBool,
                'tbx-live': state?.content?.contentType === CONTENT_TYPES.BROADCAST || state?.content?.contentType === CONTENT_TYPES.SPORT,
                'tbx-full-window': fullWindow,
                'tbx-restart': state?.content?.hasCatchUp
              });

              if (isNextEpisode && state?.content?.contentType === CONTENT_TYPES.EPISODE) {
                player.currentTime(0);
              }

              return player;
            }).catch((e) => {
              playerHandleError(e.error || e);
              console.error(e.message, e.stack);
              _cleanupPlayer();
            })

          //const player = window.player;
          dispatch(Actions.setPlayerInstance(player));
          //console.info('>>> Player built:', player, player.currentSource());

          const locationPathname = window.location.pathname;

          playerCallback.setPlayerCallback(async () => {
            return player.then(( props ) => ({
              playerID: playerCallback?.playerID || props?.id_,
              nodeElement: PLAYER_CONTAINER_REF.current,
              pathname: window.location.pathname === locationPathname ? locationPathname : null
            }))
          });

        } else {
          const playerCallbackID = playerCallback.state.playerID;
          const playerPromise = new Promise((response, reject) => {
            const playerResult = window.videojs.getPlayer(playerCallbackID);
            addOrRemoveClassNames(playerResult, {
              'tbx-hascatchup': hasCatchUpBool,
              'tbx-live': state?.content?.contentType === CONTENT_TYPES.BROADCAST || state?.content?.contentType === CONTENT_TYPES.SPORT,
              'tbx-full-window': fullWindow,
              'tbx-restart': state?.content?.hasCatchUp
            });
            response(playerResult);
          });
          playerPromise.then((p) => p.play());
          dispatch(Actions.setPlayerInstance(playerPromise));
        }

      } catch (e) {
        playerHandleError(e)
        console.error(e.message, e.stack);
        _cleanupPlayer();
      }
    }, [dispatch, TBX_UNITY_API, _cleanupPlayer]
  );

  React.useEffect(() => {
    const videoEl = playerCallback?.state?.nodeElement?.firstElementChild || PLAYER_CONTAINER_REF.current.firstElementChild;
    if (!state.player && videoEl && state.content.id && PLAYER_CONTAINER_REF?.current) {
      if (playerCallback?.state?.nodeElement?.firstElementChild && PLAYER_CONTAINER_REF?.current?.parentElement && !state.player) {
        PLAYER_CONTAINER_REF.current.parentElement.insertBefore(playerCallback.state.nodeElement, PLAYER_CONTAINER_REF.current);
        PLAYER_CONTAINER_REF.current.parentElement.removeChild(PLAYER_CONTAINER_REF.current);
      }
      _launchPlayer(
        videoEl,
        state.playerConfig,
      );
    }

  }, [PLAYER_CONTAINER_REF?.current, state, _cleanupPlayer, _launchPlayer]);

  React.useEffect(() => {
    return () => {
      if (!playerCallback?.setPlayerCallback && playerCallback) {
        console.log('>> CLEANUP PLAYER  -return: ', state?.player);
        _cleanupPlayer()
      }
    }
  }, [state?.player]);


  return;
}




/**
 * Hook for player changeSrc
 *
 * @export
 * @param {*} props
 * @param {*} context
 * @param {*} player
 */
export const useChangeSrc = (player, dispatch, changeContent, translationTexts, playerHandleError, fullWindow, _cleanupPlayer) => {

  React.useEffect(() => {
    if (changeContent?.id && player && changeContent?.contentType === CONTENT_TYPES.BROADCAST) {
      (async () => {
        try {
          const playerR = await player;
          if (!playerR) return;
          if (!playerR?.changingSrc_) {
            const hasCatchUpBool = changeContent.startTime && changeContent.endTime && changeContent.hasCatchUp && !isWithinInterval(Date.now(), {
              start: new Date(changeContent.startTime),
              end: new Date(changeContent.endTime)
            })
            addOrRemoveClassNames(playerR, {
              'tbx-hascatchup': hasCatchUpBool,
              'tbx-live': changeContent?.contentType === CONTENT_TYPES.BROADCAST,
              'tbx-restart': changeContent?.hasCatchUp,
              'tbx-full-window': fullWindow
            });
            let hasCatchUp = {};
            if (changeContent.startTime && changeContent.endTime && changeContent.hasCatchUp) {
              if (hasCatchUpBool) {
                hasCatchUp = {
                  starttime: changeContent.startTime,
                  endtime: changeContent.endTime,
                  liveProgressBar: true,
                  includeNextContent: false,
                  network: (changeContent.networks.find((e) => !!e?.network)).network
                }
              }
            }
            await playerR.titleoverlay.updateOptions({
              title: changeContent.title,  //Title for movie
              debug: true,
              contentType: changeContent.contentType,
              episode: changeContent.episode,
              season: changeContent.season,
              translationTexts: translationTexts
            });

            await playerR.changeSrc(changeContent.id, playerR, changeContent.contentType, hasCatchUp);

          }
        } catch (e) {
          playerHandleError(e.error || e);
          console.error(e.message, e.stack);
          _cleanupPlayer();
        }
      })();
    }
  }, [player, changeContent]);
};

/**
 * Hook for player events callback
 *
 * @export
 * @param {*} props
 * @param {*} context
 * @param {*} player
 */
export function usePlayerCallbacks(state, context, dispatch, setBackgroundVisible, playerHandleError, onClickBackButton, enableGoBackOnCompletion, refreshPlayerInChangeSource, _cleanupPlayer, playerCallback) {

  const handleChangeSource = React.useCallback(
    (player) => {

      const { tbx } = player || {};
      const { content } = tbx || {};
      const { id, contentType } = content || {};
      const playID = id;

      console.log('PLAYER ChangeSource');

      if (contentType === CONTENT_TYPES.EPISODE) {

        refreshPlayerInChangeSource(playID, contentType);
        player.dispose();
        if (playerCallback?.clearPlayerCallback) {
          console.log('>> CLEANUP PLAYER  IN NEXT EPISODE: ', player);
          playerCallback.clearPlayerCallback();
        }
      }

    }, []
  );

  const handleError = React.useCallback(
    (player) => {
      const error = player.error();

      if (typeof playerHandleError === 'function') {
        playerHandleError(error)
      }

      // 4 === MEDIA_ERR_SRC_NOT_SUPPORTED
      // Ver https://dev.w3.org/html5/spec-author-view/video.html#error-codes
      const isFormatUnsupported = error.code === 4;

      // Dispatch de accion generica de error para registrar en el estado
      dispatch(Actions.playbackError(error, isFormatUnsupported));

      // Si no es soportado el formato, intentar con entitlements alternativos del contenido
      //if (isFormatUnsupported) {
      //  const entitlements = getState().contents[getState().player.contentId].entitlements;
      //}
    }, [dispatch]
  );

  const handlePlaybackEnd = React.useCallback(
    (state) => {
      
      if (enableGoBackOnCompletion || state.returnCTA) {
        onClickBackButton();
      }
    }, []
  );

  const updateDuration = React.useCallback(
    (duration) => {
      dispatch(Actions.updateDuration(duration))
    }, [dispatch]
  );

  const updateFullscreenStatus = React.useCallback(
    (isFullscreen) => {
      dispatch(Actions.updateFullscreenStatus(isFullscreen))
    }, [dispatch]
  );

  const setStopNextEpisode = React.useCallback(
    () => {
      dispatch(Actions.setStopNextEpisode(true));
    }, [dispatch]
  );

  React.useEffect(() => {
    if (state?.player) {

      state.player?.then((player) => {

        player?.errorDisplay.dispose()

        player?.on('changesource', () => handleChangeSource(player));

        player?.one('ended', () => handlePlaybackEnd(state));

        player?.on('stopnextepisode', () =>  setStopNextEpisode());

        player?.on('error', handleError.bind(null, player));

        player?.on('tbxplayerblocked', (player, error) => playerHandleError(error));

        player?.on('fullscreenchange', () => {
          updateFullscreenStatus(player.isFullscreen());


        });

        player?.one('loadedmetadata', () => {
          updateDuration(player.duration());
        });

        player?.one('loadeddata', () => {
          setBackgroundVisible(false);
        });

        player?.on('pause', () => {
          console.log('pause')
          setBackgroundVisible(false);
        });

        player?.on('play', () => {
          setBackgroundVisible(false);
        })

        player?.one('_dashEnded', handlePlaybackEnd);

      })

    }
  }, [handleChangeSource, handleError, handlePlaybackEnd, state, updateDuration, updateFullscreenStatus, setBackgroundVisible])
}

/**
 * Hook Effects for player loading time error
 *
 * @export
 * @param {*} state Component state
 * @param {*} context
 * @param {*} dispatch
 */
export function usePlayerLoadingErrorCallback(player, dispatch, _cleanupPlayer, playerHandleError) {
  /*const [errorBool,setErrorBool] = React.useState(false);


  React.useEffect(()=>{
    if(errorBool){
      const timeoutID = setTimeout(()=>{
        playerHandleError({message:'Player load exceeded'});
        console.error('Player load exceeded');
        _cleanupPlayer();
      }, 30000); //20 segundos
      
      return ()=>{
        clearTimeout(timeoutID)
      }
    }
  },[errorBool])


  React.useEffect(() => {
    if (player) {
      player?.then((player) => {
        setErrorBool(true);
        player?.on('changesource', () => {
          setErrorBool(true);
        });
        player?.one('play', () => {
          setErrorBool(false);
        });
        player?.on('loadeddata', () => {
          setErrorBool(false)
        });
      })
    }
  }, [dispatch, player]);*/
}

/**
 * Hook Effects for player casting events callbacks
 *
 * @export
 * @param {*} state Component state
 * @param {*} context
 * @param {*} dispatch
 */
export function usePlayerCastCallbacks(state, context, dispatch, startCastingCallback) {

  React.useEffect(() => {
    if (state?.player && state?.playerConfig.castAppId) {

      state.player?.then((player) => {
        player?.on('stopcast', () => {
          dispatch(Actions.setIsCasting(false));
        });

        player?.on('startcast', () => {
          dispatch(Actions.setIsCasting(true));
        });

        player?.on('castnotallowed', () => {
          dispatch(Actions.castNotAllowed());
        });

      })

    }

    return () => {
      if (state.isCasting) {
        startCastingCallback && startCastingCallback(state.content, state.player);
      }
    };
  }, [dispatch, state, startCastingCallback]);
}

/**
 * Hook Effect to handle position updates
 *
 * @export
 * @param {*} state
 * @param {*} context
 * @param {*} dispatch
 * @param {*} updatePositionCallback
 */
export function usePlayerPositionUpdatesCallbacks(state, context, updatePositionCallback) {
  const lastTime = React.useRef(0);

  const handleUpdate = React.useCallback(
    () => {
      state?.player?.then((player) => {
        if (player && !player.paused()) {
          const time = player.currentTime();
          lastTime.current = time;
          updatePositionCallback && updatePositionCallback(time);
        }
      })
    }, [state, updatePositionCallback]
  );

  React.useEffect(() => {
    state?.player?.then((player) => {

      const updateEvent = () => {

        const readyState = player.readyState();

        // Si el video está cargando, evitar el dispatch la actualización de posición
        // para no producir un salto en la reproducción
        if (readyState !== HTMLMediaElement.HAVE_NOTHING ||
          readyState !== HTMLMediaElement.HAVE_METADATA) {
          const currentTime = player.currentTime();

          if (Math.abs(currentTime - lastTime.current) >= UPDATE_INTERVAL) {
            handleUpdate();
          }
        }
      };

      if (state?.player) {
        player?.on('timeupdate', updateEvent);
        player?.on('seeked', handleUpdate);
      }
    })
  }, [handleUpdate, state]);


}

export function usePlayerExitButtomVideojsAnimation(state, EXIT_BUTTON_REF, playerCallback) {

  React.useEffect(() => {

    if (playerCallback?.state?.nodeElement && !!EXIT_BUTTON_REF?.current) {
      const isExitButton = document.getElementById('playerExitButtomVideojsID');

      if (isExitButton) {
        isExitButton.remove();
      }
      playerCallback.state.nodeElement.append(EXIT_BUTTON_REF.current);
    }

  }, [playerCallback?.state, EXIT_BUTTON_REF?.current]);

  if (!!EXIT_BUTTON_REF?.current && state?.player) {
    state?.player?.then((player) => {
      player?.on(['play', 'userinactive'], () => {
        if (!player.paused() && !player.userActive() && !!EXIT_BUTTON_REF?.current?.style) {
          EXIT_BUTTON_REF.current.style.visibility = 'hidden';
          EXIT_BUTTON_REF.current.style.opacity = '0';
          EXIT_BUTTON_REF.current.style.transition = 'visibility 0s 0.5s, opacity 0.5s linear';
        };
      })
      player?.on(['pause', 'useractive'], () => {
        if (!!EXIT_BUTTON_REF?.current) {
          EXIT_BUTTON_REF.current.style.visibility = 'visible';
          EXIT_BUTTON_REF.current.style.opacity = '1';
          EXIT_BUTTON_REF.current.style.transition = 'opacity 0.5s linear';
        };
      })
    })
  }

}